export enum QueryType {
  Advanced = 'ADVANCED',
  Basic = 'BASIC',
}

export type LogQuery = string | undefined;
export type LogsFilter = Tab & { date: Date[] };
export type Tab = {
  tabId: string;
  queryType: QueryType;
  query: string;
  title: string;
  page: number;
  lastSearch?: Date;
  categoryName?: string;
  categoryId?: string | null;
  description?: string;
  headCells: string[];
  table: string;
};

type LogDataProps = {
  logsData: any[];
  isLoadingLogs: boolean;
  totals: number;
};

export interface NewLogsDashboardProps {
  filters: LogsFilter;
  setFilterAndDraft: (value: Tab, replaceById?: string) => void;
  logsDataProps: LogDataProps;
  activeLog?: string;
  setActiveLog: (value: any) => void;
  lastSearch?: Date;
  onColumnPickerApply?: any;
  currentTab?: Tab;
}

export interface LogsDashboardProps {
  filters: LogsFilter;
  setFilters: (value: LogsFilter) => void;
  logsDataProps: LogDataProps;
  activeLog?: string;
  setActiveLog: (value: any) => void;
  lastSearch?: Date;
  onColumnPickerApply?: any;
  currentTab?: Tab;
}

export type LogsQuery = {
  id?: string | null;
  name: string;
  description?: string | null;
  query: string;
  queryType: QueryType;
  logsQueryCategory?: LogsQueryCategoryType | null;
  tableName?: string | null;
  updatedAt?: string | null;
  updatedByUserId?: string | null;
};

export type LogsQueryCategoryType = {
  id?: string | null;
  name: string;
};

export type LogsPieSliceSelection = {
  color: string;
  index: number;
  value: string;
};
